import { convertToFrequency } from '../utils/payment-frequency-converter';

/**
 * Utilises the frequency conversion utils to convert a template value to
 * a given frequency. For this to work, both the from frequency and to frequency
 * need to be known.
 *
 * @param value The value to convert
 * @param fromFrequency The frequency (constants) the value is starting as
 * @param toFrequency The frequency (constants) the value is being converted to
 * @returns {undefined|*}
 */
export default (value, fromFrequency, toFrequency) => {
  if (!value) {
    return undefined;
  }
  if (!toFrequency || !fromFrequency) {
    return value;
  }
  return convertToFrequency(value, fromFrequency, toFrequency);
};
